import React from 'react'
import { AppRouter } from '@app/router/AppRouter'
import { WidgetWithConfigurationHOC, WidgetWithConfigurationProps } from './WidgetHOC'

const CtaContainer = React.lazy(() => import('@features/cta/CTA').then(m => ({ default: m.CTA })))

/**
 * @deprecated remove once LCR has migrated
 */
export const LegacyCtaWidget: React.FC<WidgetWithConfigurationProps> = ({
  customerContext,
  actionModule,
  environment,
}) => {
  return (
    <WidgetWithConfigurationHOC customerContext={customerContext} environment={environment} actionModule={actionModule}>
      <CtaContainer />
      <AppRouter />
    </WidgetWithConfigurationHOC>
  )
}
